import { useState } from 'react'
import { Button } from '@/shared/ui/button'
import { Input } from '@/shared/ui/field'
import { Icon } from '@/shared/ui/icon'
import { useChatNotifySettings } from '../model/notify-store'

export interface ChatView {
  id: string
  text: string
  authorName: string
  mine: boolean
}

interface ChatPanelProps {
  messages: ChatView[]
  onSend: (text: string) => void
  disabled?: boolean
}

export function ChatPanel({ messages, onSend, disabled = false }: ChatPanelProps) {
  const [text, setText] = useState('')
  const notifyEnabled = useChatNotifySettings((s) => s.enabled)
  const setNotifyEnabled = useChatNotifySettings((s) => s.setEnabled)

  function submit() {
    const trimmed = text.trim()
    if (!trimmed) return
    onSend(trimmed)
    setText('')
  }

  return (
    <div className="flex h-full min-h-0 flex-col gap-3">
      <div className="flex items-center justify-between gap-2">
        <span className="text-text-tertiary text-xs">Уведомления о сообщениях</span>
        <button
          type="button"
          aria-pressed={notifyEnabled}
          aria-label={notifyEnabled ? 'Отключить уведомления чата' : 'Включить уведомления чата'}
          title={notifyEnabled ? 'Отключить уведомления чата' : 'Включить уведомления чата'}
          onClick={() => setNotifyEnabled(!notifyEnabled)}
          className="rounded-control p-1 text-text-secondary transition-colors hover:text-text-primary"
        >
          <Icon name={notifyEnabled ? 'bell' : 'bell-off'} size={16} />
        </button>
      </div>
      <ul
        className="flex flex-1 flex-col gap-2 overflow-x-hidden overflow-y-auto"
        aria-label="Сообщения чата"
      >
        {messages.length === 0 ? (
          <li className="text-sm text-text-tertiary">Сообщений пока нет</li>
        ) : (
          messages.map((message) => (
            <li key={message.id} className="flex min-w-0 flex-col gap-0.5">
              <span className="label min-w-0 break-words">
                {message.mine ? 'Вы' : message.authorName}
              </span>
              {/* Длинные слова/ссылки переносятся — панель не расползается вширь. */}
              <span className="min-w-0 break-words text-sm text-text-primary">{message.text}</span>
            </li>
          ))
        )}
      </ul>

      <form
        onSubmit={(event) => {
          event.preventDefault()
          submit()
        }}
        className="flex gap-2"
      >
        <Input
          value={text}
          onChange={(event) => setText(event.target.value)}
          placeholder="Сообщение"
          aria-label="Текст сообщения"
          disabled={disabled}
        />
        <Button type="submit" size="sm" disabled={disabled}>
          Отправить
        </Button>
      </form>
    </div>
  )
}
